import React from 'react';

// Translations
import translate from './Translate.js';

class SignedOut extends React.Component {
  render() {
    const { translation } = this.props;

    return(
      <main tabIndex="0" id="main-content" className="page page--error wrap">
        <div className="panel--brief">
          <div>
            <h1 className="panel__title">{translation.heading}</h1>
            <p>{translation.message}</p>
          </div>
        </div>
      </main>
    )
  }
}

export default translate('SignedOut')(SignedOut);


// WEBPACK FOOTER //
// ./src/app/components/SignedOut.js